import { SchemaCustomerObjectService } from '@frontend/schema';
import { SalesforceAccountStatusValue, OfficeTypeValue, SalesforceAccountProductBundleValue } from './constants';
import { CustomerInfo } from './types';

export const getCustomerInfo = async (locationIds: string[]): Promise<CustomerInfo> => {
  const response = await SchemaCustomerObjectService.GetCustomerObject({
    locationIds: locationIds,
  });

  const customerInfo = response?.customerObjects?.[0] ?? {};

  return {
    accountName: customerInfo.locationName,
    accountStatus: customerInfo.accountStatus ? SalesforceAccountStatusValue[customerInfo.accountStatus] : '',
    productBundle: customerInfo.productBundle ? SalesforceAccountProductBundleValue[customerInfo.productBundle] : '',
    officeType: customerInfo.type ? OfficeTypeValue[customerInfo.type] : '',
    beta: customerInfo.beta,
  };
};
